import PropTypes from 'prop-types';
import { FormattedMessage} from 'react-intl';
import React from 'react';
import CommentAuthorAndDate from './Comment/CommentAuthorAndDate';
import CommentPinnedIcon from './Comment/CommentPinnedIcon';
import CommentNewReleaseIcon from './Comment/CommentNewReleaseIcon';

const CommentHeaderComponent = ({
                                  isOwnComment,
                                  isAuthorAdminUser,
                                  commentData,
                                  isNewComment,
                                  userSeesContent,
                                }) => {


  return (
    <div className="hearing-comment-header">
      <CommentAuthorAndDate 
        isOwnComment={isOwnComment}
        isAuthorAdminUser={isAuthorAdminUser}
        commentData={commentData}
      />
      <div className="hearing-comment-header__pins">
        {commentData.pinned && <CommentPinnedIcon/>}
        {isNewComment && <CommentNewReleaseIcon/>}
      </div>
    </div>
  );
};

CommentHeaderComponent.propTypes = {
  toggleEditor: PropTypes.func,
  handleDelete: PropTypes.func,

  isAdminUser: PropTypes.bool,
  isOwnComment: PropTypes.bool,
  commentData: PropTypes.object,
  isNewComment: PropTypes.bool,
  
  isRepliesOpen: PropTypes.bool,
  renderHideReplyButton: PropTypes.func,
  renderViewReplyButton: PropTypes.func,
};

export default CommentHeaderComponent;